import {
    type EditSubEventResponseType,
    type EditSubEventRequestType
} from "./type";
import {
    request
} from "../request";

const EditSubEvent = async (params: EditSubEventRequestType): Promise<EditSubEventResponseType> => {
    return await request<EditSubEventResponseType>("/events/editSubEvent", {
        body: JSON.stringify(params),
        method: "PUT"
    });
};

export default EditSubEvent;
